export default function (property) {
    return getComputedStyle(document.documentElement).getPropertyValue(`--${property}`).trim()
}
